import qs from 'querystring';
import BaseClient from './baseClient';

class RewriteClient extends BaseClient {
  async list(): Promise<RewriteListResponse> {
    const res: RewriteListResponse = await this.fetch('/rewrite/entries/v1');
    return res;
  }
  async listByParams(params: {
    count: number;
    indexKey: string;
  }): Promise<RewriteListResponse> {
    const res: RewriteListResponse = await this.fetch(
      `/rewrite/entries/v1?${qs.encode(params)}`,
    );
    return res;
  }
  async next(page: string): Promise<RewriteListResponse> {
    const res: RewriteListResponse = await this.fetch(page);
    return res;
  }
  async getById(id: string): Promise<RewriteItem> {
    const res: RewriteItem = await this.fetch(`/rewrite/entries/v1/${id}`);
    return res;
  }
  async getByRewriteTerm(rewriteTerm: string): Promise<RewriteItem> {
    const params = {
      rewriteTerm,
    };
    const res: RewriteListResponse = await this.fetch(
      `/rewrite/entries/v1?${qs.encode(params)}`,
    );
    return res?.objects?.[0] || null;
  }
  async normalizeRewriteTerm(rewriteTerm: string): Promise<string> {
    const res: { normalizedText: string } = await this.fetch(
      `/rewrite/text-normalize?textToNormalize=${encodeURIComponent(
        rewriteTerm,
      )}`,
    );
    return res?.normalizedText;
  }
  async create(payload: RewriteCreatePayload): Promise<RewriteItem> {
    const res = await this.fetch('/rewrite/entries/v1', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return res;
  }
  async update(
    id: string,
    payload: RewriteUpdatePayload,
  ): Promise<RewriteItem> {
    const res = await this.fetch(`/rewrite/entries/v1/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
    return res;
  }
  async delete(id: string): Promise<void> {
    await this.fetch(`/rewrite/entries/v1/${id}`, {
      method: 'DELETE',
    });
  }
}

export default new RewriteClient();
